export default __webpack_public_path__ + "static/media/kid01.55af3da5.jpg";